import React from 'react';
const Container = ({children}: {children: React.ReactNode}) => <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: '100%'}}>{children}</div>
export default Container
